import { useQuery } from "@apollo/client"
import { GET_MY_ORGANIZATION_SUBORGS } from "../graphql/queries/getMyOrganizationSuborgs"
import { OrganizationType } from "../utils/models"

type QueryType = {
  myOrganization: OrganizationType
}

export const useMyOrgSuborgs = (first: number, skip: number, orderBy?: string, search?: string) => {
  const { data, error, loading, refetch } = useQuery<QueryType>(GET_MY_ORGANIZATION_SUBORGS, {
    variables: {
      first,
      skip,
      orderBy,
      search,
    },
  })
  return {
    myOrgSuborgs: data?.myOrganization.childOrganizations,
    error,
    orgLoading: loading,
    refetch,
  }
}
